import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/Button";
import Hummingbird from "../images/corner/corner-hummingbird.webp";
import Logo from "../images/logo-dark.svg";
import Facebook from "../images/icons/facebook.svg";
import TikTok from "../images/icons/tiktok.svg";
import Instagram from "../images/icons/instagram.svg";
import YouTube from "../images/icons/youtube.svg";
import Map from "../images/map.png";
import moment from "moment";
import { tockSearchUrl } from "../utils/tock";
import { NEWSLETTER_URL } from "../utils/newsletter";
import ReservationFinder from "./ReservationFinder";

const RESERVATIONS_URL = tockSearchUrl();
const DIRECTIONS_URL =
  "https://www.google.com/maps/search/?api=1&query=117+Sharptown+Auburn+Road,+Pilesgrove,+NJ+08098";

export default function Footer() {
  return (
    <footer className="footer">
      <img
        className="corner-hummingbird footer__deco"
        src={Hummingbird}
        alt=""
      />
      <div className="container footer__inner">
        <div className="footer__brand">
          <img className="footer__logo" src={Logo} alt="auburn road logo" />
          <p className="footer__address">
            <a
              href={DIRECTIONS_URL}
              className="outgoing-link"
              target="_blank"
              rel="noreferrer noopener"
            >
              117 Sharptown Auburn Road, Pilesgrove, NJ 08098
            </a>
          </p>
          <div className="footer__social">
            <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://www.facebook.com/AuburnRoad/"
            >
              <img src={Facebook} alt="facebook icon" />
            </a>
            <a
              rel="noreferrer noopener"
              href="https://www.tiktok.com/search?lang=en&q=auburn%20road%20vineyard&t=1773952806864"
              target="_blank"
            >
              <img src={TikTok} alt="tik tok icon" />
            </a>
            <a
              rel="noreferrer noopener"
              href="https://www.instagram.com/auburnroadvineyards/"
              target="_blank"
            >
              <img src={Instagram} alt="instagram icon" />
            </a>
            <a
              rel="noreferrer noopener"
              href="https://www.youtube.com/channel/UCjDWBe2tG2QgdACnturOheA"
              target="_blank"
            >
              <img src={YouTube} alt="youtube icon" />
            </a>
          </div>
        </div>

        <div className="footer__reserve">
          <ReservationFinder className="tock-finder--full footer__finder" />
        </div>

        <div className="footer__columns">
          <div className="footer__col">
            <h3 className="footer__kicker">Learn more</h3>
            <nav className="footer__links" aria-label="Learn more">
              <Link className="footer__link" to="/our-wines">
                Our Wines
              </Link>
              <Link className="footer__link" to="/whats-happening">
                What's Happening
              </Link>
              <Link className="footer__link" to="/faq">
                FAQ
              </Link>
              <Link className="footer__link" to="/where-to-find-our-wines">
                Where to Find Our Wines
              </Link>
              <Link className="footer__link" to="/wine-stories">
                Wine Stories
              </Link>
            </nav>
          </div>

          <div className="footer__col">
            <h3 className="footer__kicker">Join us</h3>
            <nav className="footer__links" aria-label="Join us">
              <Link className="footer__link" to="/menu">
                Menu
              </Link>
              <a
                className="footer__link outgoing-link"
                href="https://auburnroadvineyards.orderport.net/wine-club"
                target="_blank"
                rel="noreferrer noopener"
              >
                CSA Wine Club
              </a>
              <a
                className="footer__link outgoing-link"
                href={RESERVATIONS_URL}
                target="_blank"
                rel="noreferrer noopener"
              >
                Reservations
              </a>
              <Link className="footer__link" to="/the-enoteca">
                The Enoteca Wine Bar
              </Link>
              <Link className="footer__link" to="/giving-back">
                Giving Back
              </Link>
              <Link className="footer__link" to="/private-events">
                Private Events
              </Link>
            </nav>
          </div>

          <div className="footer__col footer__col--newsletter">
            <h3 className="footer__kicker">Message in a Bottle</h3>
            <p className="footer__newsletter-text">
              Sign up for our "MESSAGE IN A BOTTLE" e-newsletter. No cost, no
              commitment. Just great updates and benefits.
            </p>
            <Button
              type="secondary"
              small
              external
              onClick={() => {
                window.location.href = NEWSLETTER_URL;
              }}
            >
              Sign up now
            </Button>
          </div>
        </div>

        <div className="footer__map-wrap">
          <img src={Map} className="footer__map" alt="Map of Auburn Road" />
        </div>

        <p className="footer__credit">
          Copyright &copy; {moment().format("YYYY")} Auburn Road, LLC | Site
          design &amp; development by{" "}
          <a
            className="outgoing-link"
            target="_blank"
            rel="noreferrer noopener"
            href="https://www.alvarezbrandingcompany.com"
          >
            Alvarez Branding Co.
          </a>
        </p>
      </div>
    </footer>
  );
}
